import { makeStyles } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import { createStyles, Theme } from '@material-ui/core/styles';
import { observer } from 'mobx-react';
import * as React from 'react';
import { Hint } from '../comps/Hint';
import { transl } from '../main/transl';
import { useSubmenu } from '../mainpanel/useSubmenu';
import { mg } from '../mg/mg';

const useStyles = makeStyles((theme: Theme) => createStyles({
	submenu: {
		paddingTop: theme.spacing(1),
		paddingBottom: theme.spacing(1),
		margin: theme.spacing(1, 0, 0, 0),
		width: '100%',
		display: 'flex',
	},
	gap: {
		marginLeft: 'auto',
	},
	item: {
		padding: '8px !IMPORTANT',
	},
	button: {
		marginBottom: theme.spacing(2),
	},
	disabled: {
		backgroundColor: '#EEE !important',
	},
}));

export interface ISubmenuObject {
	name: string;
	onClick() : void;
	disabled?: any,
	tooltip?: string,
}

export type ISubmenuArray = Array<string | ISubmenuObject | React.ReactElement | null>

export const Submenu = observer(function Submenu(props: {children?: ISubmenuArray}) {
	const classes = useStyles();
	const obsolete = useSubmenu();
	const children = props.children ?? obsolete;
	if (!children.length) return <div>&nbsp;</div>;

	const makeButton = (i: ISubmenuObject) => <Grid item key={i.name} className={classes.item}>
		<Hint key={i.name} disabled={i.disabled} tooltip={i.tooltip}>
			<Button
				variant="outlined"
				color={i.disabled ? 'default' : 'primary'}
				className={mg.clsn(classes.button, {[classes.disabled]: i.disabled})}
				onClick={i.disabled ? undefined : i.onClick}
			>
				{transl(i.name)}
			</Button>
		</Hint>
	</Grid>;

	const makeElement = (i: ISubmenuArray[0]) : JSX.Element | null => {
		if (!i) return null;
		if (React.isValidElement(i)) return i;
		mg.assertTrue(typeof i !== 'string' || i === '---');
		if (typeof i === 'string') return <div key={i} className={classes.gap}/>;
		return makeButton(i);
	};

	return <Grid container spacing={8} wrap="wrap" className={mg.clsn(classes.submenu)}>
		{children.map(makeElement)}
	</Grid>;
});
